import useListOrg from 'pages/Dboard/useListOrg';
import React, { useState, useEffect } from 'react'
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody, Spinner, Pagination, PaginationItem, PaginationLink } from "reactstrap";
import OrgAddEditForm from './OrgAddEditForm';
import useUpdateOrgStatus from './useUpdateOrgStatus';
import { FaEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import useDeleteOrg from './useDeleteOrg';

const OrganizationsPage = () => {
    // pagination
    const[currentPage,setCurrentPage]=useState(1);
    const pageSize = 10;

    const [loggedRole,setLoggedRole] = useState()
    // getting data from local storage
    useEffect(()=>{
      const roleData = JSON.parse(localStorage.getItem('userData'))
      if(roleData){
          const role = roleData.user.role;
          setLoggedRole(role);
      }
        
    },[])

    // search
    const[searchTerm, setSearchTerm]=useState('');
    // hook for getting the org data
    const{isPending, isSuccess, isError, error, data} = useListOrg(currentPage,pageSize,searchTerm)
    // hook for updating the  org status
    const{isUpdating, isUpdated, updateOrgStatus} = useUpdateOrgStatus();
    // hook for handling the org deletion
    const{isDeleting, isDeleted, deleteOrg} = useDeleteOrg();

    const orgs = data?.results || []
    const totalCount = data?.count || 0;
    const totalPages = Math.ceil(totalCount/pageSize)

    console.log("org page:",orgs)

    // Style object for the sticky table headers
  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1, // Ensures header is above the scrolling content
  };

    // for modal
    const[isOpen,setIsOpen] = useState(false);
    // state to track whether its add or edit
    const[isEditMode,setIsEditMode]=useState(false)
    // stores org data for editing
    const[selectedOrg,setSelectedOrg]=useState(null)
    
  const AddModal=()=>{
    setIsEditMode(false)
    setSelectedOrg(null)
    setIsOpen(true)
  }

  const EditModal=(org)=>{
    setIsEditMode(true)
    setSelectedOrg(org)
    setIsOpen(true)
  }

  const closeModal=()=>{
    setIsEditMode(false)
    setSelectedOrg(null)
    setIsOpen(false)
  }
  // status change handle submit
  const handleStatusChange=(newStatus, orgId)=>{
    const updatedStatus={
      "orgId":orgId,
      "newStatus":newStatus
    }

    updateOrgStatus(updatedStatus)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row className="mb-4 align-items-center">
            <Col style={{ paddingLeft: "32px" }}>
              <h2 style={{ fontFamily: "unset" }}>Organizations</h2>
            </Col>
            <Col>
                {/* search */}
                    <input
                        type="text" 
                        className="form-control"
                        placeholder="Search by Organization Name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
            </Col>
            <Col className="text-end">
              <div>
                <Button onClick={AddModal} className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }}>
                  Add Organization
                </Button>
              </div>
            </Col>
          </Row>
          {/* Modal */}
          <Modal isOpen={isOpen} size="xl" backdrop="static" keyboard={false} toggle={null} fullscreen="xl" fade scrollable centered={true}>
            <ModalHeader close={
              <button type="button" className="btn-close" onClick={closeModal}/>
            }>
                Add Organization details here
            </ModalHeader>
            <ModalBody>
              <OrgAddEditForm
                isEditMode={isEditMode}
                orgData={selectedOrg}
                onClose={closeModal}
              />
            </ModalBody>
          </Modal>
          {/* next row */}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    {/* This div is the scroll container */}
                    <div
                      className="table-responsive mb-0"
                      style={{ maxHeight: "400px",minHeight:"340px", overflowY: "auto" }}
                    >
                      <Table className="table table-striped table-bordered">
                        <Thead>
                          <Tr>
                            {/* Apply the sticky style to each header cell */}
                            <Th style={stickyHeaderStyle}>SL.No</Th>
                            <Th style={stickyHeaderStyle}>Name</Th>
                            <Th style={stickyHeaderStyle}>Address</Th>
                            <Th style={stickyHeaderStyle}>Status</Th>
                            <Th style={stickyHeaderStyle}>Actions</Th>

                          </Tr>
                        </Thead>
                        <Tbody>
                          {isPending ? (
                            <Tr>
                              <Td colSpan="5" className="text-center">
                                <Spinner color="primary" />
                              </Td>
                            </Tr>
                          ) : (
                            Array.isArray(orgs) &&
                            orgs.filter((org)=>{
                              const term = searchTerm.toLowerCase();
                              return(
                                org.name?.toLowerCase().includes(term)
                              )
                            }) .map((org, index) => (
                              <Tr key={index}>
                                <Td>{index + 1}</Td>
                                <Td>{org.name}</Td>
                                <Td>
                                  {org.address
                                    ? [org.address.addr_line1, org.address.city, org.address.state_code]
                                        .filter(Boolean)
                                        .join(', ') + (org.address.zip_code ? ` - ${org.address.zip_code}` : '')
                                    : 'Nil'}
                                </Td>
                                <Td>
                                  <select
                                    className='form-select border-primary-subtle'
                                    value={org.status}
                                    onChange={(e)=> handleStatusChange(e.target.value, org.org_id)}
                                  >
                                    {org.status_choices?.map((status,index)=>(
                                      <option key={index} value={status.value}>{status.label}</option>
                                    ))}
                                  </select>
                                </Td>
                                <Td>
                                  <div style={{ display: "flex", flexDirection: "row",alignItems:"center", gap:"0.5rem"}}>
                                    <Button
                                      style={{backgroundColor: "#00ADF0", color: "white",fontWeight: "bolder" }}
                                      size="sm"
                                      outline
                                      onClick={() => EditModal(org)}
                                    >
                                      {<FaEdit/>}
                                    </Button>
                                    {/* {loggedRole === "00000000-0000-0000-0000-000000000001" && <Button 
                                      color="danger" outline size="sm" type="button"
                                      onClick={()=> deleteOrg(org.org_id)}
                                    >
                                      <FaTrashAlt/>
                                    </Button>} */}
                                    {/* delbutton */}
                                    {/* <Button 
                                      color="danger" outline size="sm" type="button"
                                      onClick={()=> deleteOrg(org.org_id)}
                                    >
                                      <FaTrashAlt/>
                                    </Button> */}
                                  </div>
                                </Td>
                              </Tr>
                            ))
                          )}
                        </Tbody>

                      </Table>
                      <div style={{display:"flex", flexDirection:"row", alignItems:"end", justifyContent:"end"}}>
                                <Pagination size="sm" className="justify-content-center">
                                {/* First Page */}
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                    first
                                    onClick={() => setCurrentPage(1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Previous Page */}
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink
                                    previous
                                    onClick={() => setCurrentPage(prev => prev - 1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Page Numbers */}
                                {[...Array(totalPages)].map((_, index) => {
                                    const isActive = currentPage === index + 1;
                                    return (
                                    <PaginationItem key={index} active={isActive}>
                                        <PaginationLink
                                        onClick={() => setCurrentPage(index + 1)}
                                        style={{
                                            backgroundColor: isActive ? '#007bff' : '#fff',
                                            color: isActive ? '#fff' : '#007bff',
                                            border: '1px solid #dee2e6',
                                            padding: '5px 12px',
                                            margin: '0 2px',
                                            cursor: 'pointer',
                                            borderRadius: '4px',
                                            fontWeight: isActive ? 'bold' : 'normal',
                                        }}
                                        >
                                        {index + 1}
                                        </PaginationLink>
                                    </PaginationItem>
                                    );
                                })}

                                {/* Next Page */}
                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                    next
                                    onClick={() => setCurrentPage(prev => prev + 1)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>

                                {/* Last Page */}
                                <PaginationItem disabled={currentPage === totalPages}>
                                    <PaginationLink
                                    last
                                    onClick={() => setCurrentPage(totalPages)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#007bff',
                                        border: '1px solid #dee2e6',
                                        padding: '5px 10px',
                                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                    }}
                                    />
                                </PaginationItem>
                            </Pagination>
                            </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          
        </div>
      </div>
    </React.Fragment>
  );
}

export default OrganizationsPage